import styles from 'styles/Slogan.module.css';

export const Slogan = () => {
    return (
        <div className={styles.slogan}>
            <p data-cy='slogan-msg'>Empower your trucking business with AI</p>
        </div>
    );
};
